import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PlacementDetailsForNRO = lazy(() =>
  import("@scenes/Placements/PlacementDetails/PlacementDetails").then((module) => ({
    default: module.PlacementDetails,
  }))
);

export const placementDetailsNRO: NavigationRoutingObject = {
  Component: PlacementDetailsForNRO,
  componentFeatureFlippers: ["banners", "placement_details_nro_component"],
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("placement-details-nro-heading", "Placement Details"),
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("banners") &&
      featureOn("placement_details_nro_component") &&
      (hasPermission("appGroup", { permission: "basicReadOnly" }) ||
        (featureOn("content_cards_permissions_placements") &&
          hasPermission("appGroup", { permission: "viewPlacements" })))
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/app_settings/app_settings/placements/:appGroupId",
};
